import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

const CompletionFunnelChart = ({ data }) => {
  const COLORS = ['#3B82F6', '#8B5CF6', '#10B981', '#F59E0B', '#DC2626'];

  return (
    <div className="bg-card rounded-lg p-6 shadow-brand">
      <h3 className="text-lg font-semibold text-foreground mb-4">Registration Completion Funnel</h3>
      <div className="w-full h-80" aria-label="Registration Completion Funnel Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis type="number" stroke="#6B7280" />
            <YAxis dataKey="stage" type="category" stroke="#6B7280" width={150} />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#FFFFFF', 
                border: '1px solid #E5E7EB',
                borderRadius: '0.5rem'
              }}
            />
            <Legend />
            <Bar dataKey="users" fill="#3B82F6" name="Users" radius={[0, 8, 8, 0]}>
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CompletionFunnelChart;